import axios from "axios";
import { API_URL } from "../../../utils/constants";

export const addGCPAccountApi = async (postData) => {
  try {
    const formData = new FormData();
    formData.append("account_type", "gcp");
    formData.append("account_id", postData.account_id);
    formData.append("account_name", postData.account_name);
    formData.append("service_account_key", postData.service_account_key);

    return await axios({
      method: "POST",
      url: `${API_URL}add-account`,
      data: {
        account_type: "gcp",
        account_id: postData.account_id,
        account_name: postData.account_name,
        account_details: postData.service_account_info,
      },
      headers: { "Content-Type": "application/json" },
    });
  } catch (e) {
    return e;
  }
};
